<template>
  <div class="plugin-manage-container">
    <!-- 搜索区域 -->
    <div class="search-bar">
      <!-- 新增按钮 -->
      <div class="action-buttons" v-if="hasManagePermission">
        <el-button
            type="primary"
            @click="handleAdd"
        >新增插件</el-button>
      </div>

      <!-- 插件类型选择 -->
      <el-select
          v-if="hasManagePermission"
          v-model="searchType"
          placeholder="选择插件类型"
          clearable
          style="width: 150px; margin-left: 10px;"
          @change="handleTypeChange"
      >
        <el-option
            v-for="type in pluginTypes"
            :key="type.id"
            :label="type.name"
            :value="type.id"
        />
      </el-select>

      <!-- 搜索框 -->
      <el-input
          v-model="searchKeyword"
          placeholder="输入插件名称或编码搜索"
          clearable
          :style="hasManagePermission ? 'width: 230px; margin-left: 10px;' : 'width: 230px; margin: 0;'"
          @clear="clearSearch"
          @keyup.enter="searchProducts"
      />
      <el-button
          style="width: 80px; margin-left: 10px;"
          type="primary"
          @click="searchProducts"
          :loading="searchLoading"
      >搜索</el-button>

    </div>

<!--    <h2 class="page-title">插件信息</h2>-->

    <el-table
        :data="products"
        v-loading="loading"
        class="product-table"
        stripe
        style="width: 100%"
        border
    >
      <el-table-column v-if="false" prop="id" label="ID" width="185" align="center" />

      <el-table-column prop="productCode" label="插件编码" :width="hasManagePermission ? 120 : 200" align="center" />

      <el-table-column prop="name" label="插件名称" :width="hasManagePermission ? 160 : 200" align="center" />

      <el-table-column prop="productTypeName" label="类型" width="120" align="center" v-if="hasManagePermission" />

      <el-table-column prop="version" :label="hasManagePermission ? '当前版本' : '使用版本'" :width="hasManagePermission ? 120 : 140" align="center" />

      <el-table-column label="图标" :width="hasManagePermission ? 120 : 180" align="center">
        <template #default="scope">
          <el-image
              v-if="scope.row.iconUrl"
              style="width: 30px; height: 30px; cursor: pointer;"
              :src="scope.row.iconUrl"
              :preview-src-list="[scope.row.iconUrl]"
              preview-teleported
              fit="cover"
          >
            <template #error>
              <div class="image-slot">
                <el-icon><Picture /></el-icon>
              </div>
            </template>
          </el-image>
          <span v-else style="color: #909399;">暂无icon</span>
        </template>
      </el-table-column>

      <el-table-column label="单价(元)" width="100" align="center" v-if="hasManagePermission">
        <template #default="scope" >
          <span style="color: #f56c6c; font-weight: 500;">
             {{ scope.row.price != null ? `¥${Number(scope.row.price).toFixed(2)}` : '-' }}
          </span>
        </template>
      </el-table-column>

      <el-table-column label="状态" width="100" align="center" v-if="hasManagePermission">
        <template #default="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
            {{ scope.row.status === 1 ? '在售' : '下架' }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column v-if="hasManagePermission" prop="storageUrl" label="文件路径" width="160" align="center">
        <template #default="scope">
          <span v-if="scope.row.storageUrl" style="color: #67c23a;">
            {{ getFileName(scope.row.storageUrl) }}
          </span>
          <span v-else style="color: #909399;">无文件</span>
        </template>
      </el-table-column>

      <el-table-column
          label="下载量"
          width="80"
          align="center"
          v-if="hasManagePermission">
        <template #default="scope">
          <el-button
              link
              type="primary"
              @click="handleDownloadStats(scope.row)"
              :loading="statsLoading === scope.row.id">
            {{ scope.row.downloadCount || 0 }}
          </el-button>
        </template>
      </el-table-column>

      <el-table-column v-if="hasManagePermission" prop="updatedAt" label="更新时间" width="120" >
        <template #default="scope">
          {{ formatTime(scope.row.updatedAt) }}
        </template>
      </el-table-column>

      <el-table-column prop="description" label="描述" :width="hasManagePermission ? 180 : 280" align="center" show-overflow-tooltip />


      <el-table-column prop="productExpireTime" label="到期时间" align="center" v-if="!hasManagePermission">
        <template #default="scope">
          <span :class="getExpireTimeClass(scope.row.productExpireTime)">
            {{ formatTime(scope.row.productExpireTime) }}
            {{ getExpireTimeStatus(scope.row.productExpireTime) }}
          </span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" fixed="right" v-if="hasManagePermission">
        <template #default="scope">

          <!-- 下载按钮 -->
<!--          <el-button-->
<!--              size="small"-->
<!--              type="primary"-->
<!--              @click="handleDownload(scope.row)"-->
<!--              :disabled="!scope.row.storageUrl"-->
<!--          >下载程序</el-button>-->

          <el-button
              size="small"
              :type="scope.row.status === 1 ? 'danger' : 'success'"
              @click="handleStatusChange(scope.row)"
          >{{ scope.row.status === 1 ? '下架' : '上架' }}</el-button>

          <el-button
              size="small"
              type="warning"
              @click="handleEdit(scope.row)"
          >修改</el-button>
          <el-button
              size="small"
              type="danger"
              @click="handleDelete(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <div class="pagination-container">
      <el-pagination
          v-model:current-page="currentPage"
          :page-size="pageSize"
          :total="total"
          :pager-count="5"
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
      />
    </div>

    <!-- 添加/修改插件弹窗 -->
    <el-dialog
        :title="dialogTitle"
        v-model="dialogVisible"
        width="600px"
        :close-on-click-modal="false"
        @close="handleDialogClose"
    >
      <el-form
          ref="productFormRef"
          :model="productForm"
          :rules="productFormRules"
          label-width="100px"
      >
        <!-- 插件编码 -->
        <el-form-item label="插件编码" prop="productCode">
          <el-input
              v-model="productForm.productCode"
              placeholder="请输入插件编码"
          />
        </el-form-item>

        <!-- 插件名称 -->
        <el-form-item label="插件名称" prop="name">
          <el-input
              v-model="productForm.name"
              placeholder="请输入插件名称"
              :disabled="isEdit"
          />
        </el-form-item>

        <!-- 版本号 -->
        <el-form-item label="版本号码" prop="version">
          <el-input
              v-model="productForm.version"
              placeholder="请输入版本号"
          />
        </el-form-item>

        <!-- 价格 -->
        <el-form-item label="插件价格" prop="price">
          <el-input-number
              v-model="productForm.price"
              :min="0"
              :precision="2"
              placeholder="请输入价格"
          />
        </el-form-item>

        <!-- 插件类型 - 修改时显示为文本，新增时显示为下拉菜单 -->
        <el-form-item label="插件类型" prop="productTypeId">
          <el-input
              v-if="isEdit"
              v-model="productForm.productTypeName"
              disabled
              placeholder="插件类型"
          />
          <el-select
              v-else
              v-model="productForm.productTypeId"
              placeholder="请选择插件类型"
          >
            <el-option
                v-for="type in pluginTypes"
                :key="type.id"
                :label="type.name"
                :value="type.id"
            />
          </el-select>
        </el-form-item>

        <!-- 程序文件 -->
        <el-form-item label="程序文件">
          <el-upload
              class="plugin-upload"
              action="#"
              :show-file-list="false"
              :before-upload="beforePluginUpload"
              :http-request="handlePluginUpload"
              accept=".exe"
              :disabled="pluginUploading"
          >
          <el-button size="small" type="primary" :disabled="pluginUploading">
            {{ pluginUploading ? '上传中...' : '点击上传' }}
          </el-button>
          <template #tip>
            <div class="el-upload__tip">
              只能上传 .exe 文件，且不超过100MB
            </div>
          </template>
          </el-upload>

          <!-- 上传进度条 -->
          <div v-if="pluginUploading" class="upload-progress">
            <el-progress
                :percentage="uploadProgress"
                :status="uploadProgress === 100 ? 'success' : ''"
                :stroke-width="8"
            />
            <div class="progress-text">
              上传进度: {{ uploadProgress }}%
              <span v-if="uploadProgress === 100" class="success-text">上传完成!</span>
            </div>
          </div>

          <!-- 显示已上传的文件 -->
          <div v-if="productForm.storageUrl && !pluginUploading" class="file-info">
            <el-tag type="success" style="margin-top: 10px;">
              {{ getFileName(productForm.storageUrl) }}
            </el-tag>
            <el-button
                size="mini"
                type="danger"
                @click="removePluginFile"
                :disabled="submitLoading"
            >
              删除
            </el-button>
          </div>

          <div v-else-if="!pluginUploading" class="file-info">
            <span style="color: #909399; font-size: 12px;">暂无程序文件</span>
          </div>
        </el-form-item>

        <!-- 插件icon -->
        <el-form-item label="插件图标">
          <el-upload
              class="icon-upload"
              action="#"
              :show-file-list="false"
              :before-upload="beforeIconUpload"
              :http-request="handleIconUpload"
              accept=".jpg,.jpeg,.png,.gif,.bmp,.webp,.ico,.icon"
          >
            <el-button size="small" type="primary">
              点击上传
            </el-button>
            <template #tip>
              <div class="el-upload__tip">
                只能上传 jpg/png/gif/bmp/webp/ico/icon 文件，且不超过10MB  <!-- 更新提示 -->
              </div>
            </template>
          </el-upload>

          <!-- 显示已上传的图片 -->
          <div v-if="productForm.iconUrl" class="icon-preview">
            <el-image
                style="width: 80px; height: 60px; margin-top: 10px;"
                :src="productForm.iconUrl"
                fit="cover"
                :preview-src-list="[productForm.iconUrl]"
                preview-teleported
            />
            <div class="icon-actions">
              <el-button size="mini" @click="previewIcon">预览</el-button>
              <el-button size="mini" type="danger" @click="removeIcon" :disabled="submitLoading">删除</el-button>
            </div>
          </div>

          <div v-else class="icon-preview">
            <span style="color: #909399; font-size: 12px;">暂无图标</span>
          </div>
        </el-form-item>

        <!-- 插件描述 -->
        <el-form-item label="插件描述" prop="description">
          <el-input
              v-model="productForm.description"
              type="textarea"
              :rows="3"
              placeholder="请输入插件描述"
          />
        </el-form-item>

        <!-- 状态（仅新增时显示） -->
        <el-form-item label="状态" prop="status" v-if="!isEdit">
          <el-radio-group v-model="productForm.status">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="0">下架</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button
            type="primary"
            @click="handleSubmit"
            :loading="submitLoading"
        >确认</el-button>
      </template>
    </el-dialog>

    <!-- 下载统计图表弹窗 -->
    <el-dialog
        :title="`${currentProductName}`"
        v-model="statsDialogVisible"
        width="1200px"
        :close-on-click-modal="false"
        @close="handleStatsDialogClose">

      <div v-loading="chartLoading" class="chart-container">
        <div ref="chartRef" style="width: 100%; height: 500px;"></div>
      </div>


    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, nextTick, computed, onBeforeUnmount } from 'vue'
import * as echarts from 'echarts';
import { ElMessage, ElMessageBox } from 'element-plus'
import { Picture, Refresh, Plus } from '@element-plus/icons-vue'
import request from '@/utils/request'
import { isSuperAdmin } from '@/utils/auth'

// 响应式数据
const products = ref([])
const loading = ref(false)
const searchKeyword = ref('')
const searchLoading = ref(false)
const searchType = ref('')
const pluginTypes = ref([])

// 上传进度相关变量
const pluginUploading = ref(false) // 程序文件上传状态
const uploadProgress = ref(0)      // 上传进度百分比

// 统计相关变量
const statsDialogVisible = ref(false)
const chartLoading = ref(false)
const currentProductName = ref('')
const chartRef = ref(null)
let chartInstance = null

// 分页相关变量
const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(0)

// 插件类型加载状态
const typesLoading = ref(false)

// 权限相关
const isSuperAdminRole = ref(false)

// 是否有管理权限
const hasManagePermission = computed(() => {
  return isSuperAdminRole.value
})

// 弹窗相关数据
const dialogVisible = ref(false)
const dialogTitle = ref('')
const isEdit = ref(false)
const submitLoading = ref(false)
const productFormRef = ref()

// 插件表单数据
const productForm = reactive({
  id: null,
  productCode: '',      // 插件编码
  name: '',             // 插件名称
  version: '',          // 版本号
  price: null,          // 价格
  productTypeId: null,  // 插件类型ID
  productTypeName: '',  // 显示类型名称
  storageUrl: '',       // 文件路径
  iconUrl: '',          // 插件icon
  description: '',      // 插件描述
  status: 1,            // 状态
  iconFile: null,       // 图标文件对象（新增模式使用）
  pluginFile: null      // 程序文件对象（新增模式使用）
})

// 表单验证规则
const productFormRules = {
  productCode: [
    { required: true, message: '请输入插件编码', trigger: 'blur' }
  ],
  name: [
    { required: true, message: '请输入插件名称', trigger: 'blur' }
  ],
  version: [
    { required: true, message: '请输入版本号', trigger: 'blur' }
  ],
  price: [
    { required: true, message: '请输入价格', trigger: 'blur' }
  ],
  productTypeId: [
    {
      required: true,
      message: '请选择插件类型',
      trigger: 'change',
      // 只在新增时验证插件类型
      validator: (rule, value, callback) => {
        if (!isEdit.value && !value) {
          callback(new Error('请选择插件类型'))
        } else {
          callback()
        }
      }
    }
  ],
  description: [
    { required: true, message: '请输入插件描述', trigger: 'blur' }
  ]
}

// 获取用户权限
const getUserPermissions = async () => {
  try {
    isSuperAdminRole.value = await isSuperAdmin()
    console.log('插件管理权限状态 - 超级管理员:', isSuperAdminRole.value)
  } catch (error) {
    console.error('获取用户权限失败:', error)
  }
}

// 获取插件类型
const fetchPluginTypes = async () => {
  typesLoading.value = true
  try {
    const response = await request.get('/plugin/types')
    if (response.code === '200') {
      pluginTypes.value = response.data || []
      console.log('获取到的插件类型:', pluginTypes.value)
    } else {
      // ElMessage.error(response.message || '获取插件类型失败')
      pluginTypes.value = []
    }
  } catch (error) {
    console.error('获取插件类型失败:', error)
    // ElMessage.error('获取插件类型失败: ' + (error.message || '网络错误'))
    pluginTypes.value = []
  } finally {
    typesLoading.value = false
  }
}

// 获取插件列表
const fetchProducts = async () => {
  loading.value = true
  try {
    const response = await request.get('/plugin/all/products', {
      params: {
        page: currentPage.value,
        size: pageSize.value
      }
    })
    if (response.code === '200') {
      products.value = response.data.list || []
      total.value = response.data.total
      // ElMessage.success(`成功加载 ${products.value.length} 条插件信息`)
    } else {
      // ElMessage.error(response.message || '获取插件信息失败')
    }
  } catch (error) {
    console.error('获取插件信息失败:', error)
    // ElMessage.error('获取插件信息失败: ' + (error.message || '网络错误'))
  } finally {
    loading.value = false
  }
}

// 监听类型变化
const handleTypeChange = () => {
  if (searchType.value) {
    searchProductsByType()
  } else {
    // 如果清空了类型选择，重新加载所有数据
    fetchProducts()
  }
}

// 根据类型搜索插件
const searchProductsByType = async () => {
  if (!searchType.value) {
    fetchProducts()
    return
  }

  searchLoading.value = true
  console.log("类型typeId" + searchType.value)
  try {
    const response = await request.get('/plugin/search/products/byType', {
      params: {
        typeId: searchType.value,
        keyword: searchKeyword.value, // 可选，同时支持关键词搜索
        page: currentPage.value,
        size: pageSize.value
      }
    })
    if (response.code === '200') {
      products.value = response.data.list || []
      total.value = response.data.total

      if (products.value.length === 0) {
        ElMessage.info('该分类下暂无插件')
      } else {
        ElMessage.success(`找到 ${products.value.length} 个插件`)
      }
    } else {
      ElMessage.error(response.message || '搜索插件失败')
    }
  } catch (error) {
    console.error('按类型搜索插件失败:', error)
    ElMessage.error('搜索插件失败: ' + (error.message || '网络错误'))
  } finally {
    searchLoading.value = false
  }
}

// 清空搜索
const clearSearch = () => {
  searchKeyword.value = ''
  // 如果类型选择不为空，则根据类型重新加载数据
  if (searchType.value) {
    searchProductsByType()
  } else {
    fetchProducts()
  }
}

// 搜索插件
const searchProducts = async () => {
  // 如果有类型选择，优先按类型搜索
  if (searchType.value) {
    await searchProductsByType()
  } else if (!searchKeyword.value.trim()) {
    fetchProducts()
    return
  } else {
    // 原有的关键词搜索逻辑
    searchLoading.value = true
    try {
      const response = await request.get('/plugin/search/products', {
        params: {
          keyword: searchKeyword.value,
          page: currentPage.value,
          size: pageSize.value
        }
      })
      if (response.code === '200') {
        products.value = response.data.list || []
        total.value = response.data.total

        if (products.value.length === 0) {
          ElMessage.info('未找到匹配的产品')
        } else {
          // ElMessage.success(`找到 ${products.value.length} 个匹配的插件`)
        }
      } else {
        ElMessage.error(response.message || '搜索插件失败')
      }
    } catch (error) {
      console.error('搜索插件失败:', error)
      ElMessage.error('搜索插件失败: ' + (error.message || '网络错误'))
    } finally {
      searchLoading.value = false
    }
  }
}

// 新增插件
const handleAdd = () => {
  dialogTitle.value = '新增插件'
  isEdit.value = false
  // 重置表单
  Object.assign(productForm, {
    id: null,
    productCode: '',
    name: '',
    version: '',
    price: null,
    productTypeId: null,
    productTypeName: '',
    storageUrl: '',
    iconUrl: '',
    description: '',
    status: 1,
    iconFile: null,
    pluginFile: null
  })
  dialogVisible.value = true
}

// 修改插件
const handleEdit = (row) => {
  dialogTitle.value = '修改插件'
  isEdit.value = true

  // 查找插件类型名称
  // 优先使用当前行中的 productTypeName
  let typeName = row.productTypeName || ''

  // 如果当前行没有插件类型名称，尝试从插件类型列表中查找
  if (!typeName && row.productTypeId) {
    const foundType = pluginTypes.value.find(type => {
      // 确保比较相同的数据类型
      return Number(type.id) === Number(row.productTypeId)
    })
    typeName = foundType ? foundType.name : ''
  }

  // 填充表单数据（注意：修改时只能修改插件编码和价格）
  Object.assign(productForm, {
    id: row.id,
    productCode: row.productCode,        // 可修改
    name: row.name,                      // 不可修改
    version: row.version,                // 可修改
    price: row.price,                    // 可修改
    productTypeId: row.productTypeId,    // 不可修改
    productTypeName: typeName,           // 设置类型名称
    storageUrl: row.storageUrl,          // 可修改
    iconUrl: row.iconUrl,                // 可修改
    description: row.description,        // 可修改
    status: row.status                   // 不可修改
  })
  dialogVisible.value = true
}

// 删除插件
const handleDelete = async (row) => {
  try {
    await ElMessageBox.confirm(
        `确定要删除插件 "${row.name}" 吗？`,
        '删除确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
    )

    const response = await request.delete(`/plugin/delete/products/${row.id}`)
    if (response.code === '200') {
      ElMessage.success('删除成功')
      fetchProducts() // 刷新列表
    } else {
      ElMessage.error(response.message || '删除失败')
    }
  } catch (error) {
    if (error !== 'cancel') {
      console.error('删除失败:', error)
      ElMessage.error('删除失败: ' + (error.message || '网络错误'))
    }
  }
}

// 下载插件
// const handleDownload = (row) => {
//
//   // 创建下载链接
//   const downloadUrl = `/api/file/download-plugin/${row.id}`;
//
//   // 直接打开新窗口下载
//   window.location.href = downloadUrl;
//
//   ElMessage.success('开始下载插件程序文件');
//
// }

// 分页变化处理
const handleCurrentChange = (page) => {
  currentPage.value = page
  // 根据当前搜索状态决定调用哪个方法
  if (searchType.value) {
    searchProductsByType()
  } else if (searchKeyword.value) {
    searchProducts()
  } else {
    fetchProducts()
  }
}

// 图标上传前的验证
const beforeIconUpload = (file) => {
  const isImage = /\.(jpg|jpeg|png|gif|bmp|webp|ico|icon)$/i.test(file.name);  // 添加 ico 和 icon
  const isLt10M = file.size / 1024 / 1024 < 10;  // 保持10MB限制

  if (!isImage) {
    ElMessage.error('只能上传图片格式文件 (JPEG, JPG, PNG, GIF, BMP, WEBP, ICO, ICON)!');
    return false;
  }
  if (!isLt10M) {
    ElMessage.error('图片大小不能超过 10MB!');
    return false;
  }
  return true;
}

// 处理图标上传
const handleIconUpload = async (options) => {
  const { file } = options;

  try {
    const formData = new FormData();
    formData.append('file', file);

    // 如果是修改模式，直接上传并更新
    if (isEdit.value && productForm.id) {
      const response = await request.post(`/file/upload/icon/${productForm.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.code === '200') {
        productForm.iconUrl = response.data;
        ElMessage.success('图标上传成功');
        // 刷新列表以更新图标显示
        fetchProducts();
      } else {
        ElMessage.error(response.message || '图标上传失败');
      }
    } else {
      // 新增模式，先预览，等提交时再统一处理
      // 这里可以创建一个临时URL用于预览
      productForm.iconUrl = URL.createObjectURL(file);
      productForm.iconFile = file; // 保存文件对象
      ElMessage.success('图标已选择，保存时将一起上传');
    }
  } catch (error) {
    console.error('图标上传失败:', error);
    ElMessage.error('图标上传失败: ' + (error.message || '网络错误'));
  }
}

// 程序文件上传前的验证
const beforePluginUpload = (file) => {
  const isExe = /\.exe$/i.test(file.name);
  const isLt100M = file.size / 1024 / 1024 < 100;   // 最大为100MB

  if (!isExe) {
    ElMessage.error('只能上传 .exe 文件!');
    return false;
  }
  if (!isLt100M) {
    ElMessage.error('文件大小不能超过 100MB!');
    return false;
  }
  return true;
}

// 处理程序文件上传
const handlePluginUpload = async (options) => {
  const { file } = options;

  // 如果是修改模式且有产品ID，才显示进度条
  if (isEdit.value && productForm.id) {
    pluginUploading.value = true;
    uploadProgress.value = 0;

    try {
      const formData = new FormData();
      formData.append('file', file);

      // 使用axios的onUploadProgress监控上传进度
      const response = await request.post(`/file/upload/plugin/${productForm.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            uploadProgress.value = progress;
          }
        }
      });

      if (response.code === '200') {
        productForm.storageUrl = response.data;
        uploadProgress.value = 100; // 确保显示100%

        // 延迟一下让用户看到100%的进度
        setTimeout(() => {
          pluginUploading.value = false;
          ElMessage.success('程序文件上传成功');
        }, 500);
      } else {
        pluginUploading.value = false;
        ElMessage.error(response.message || '程序文件上传失败');
      }
    } catch (error) {
      pluginUploading.value = false;
      console.error('程序文件上传失败:', error);

      if (error.code === 'ECONNABORTED') {
        ElMessage.error('上传超时，请检查网络连接或尝试重新上传');
      } else {
        ElMessage.error('程序文件上传失败: ' + (error.message || '网络错误'));
      }
    }
  } else {
    // 新增模式，不显示进度条，直接保存文件对象
    try {
      productForm.pluginFile = file;
      productForm.storageUrl = file.name; // 临时显示文件名
      ElMessage.success('程序文件已选择，保存时将一起上传');
    } catch (error) {
      console.error('文件处理失败:', error);
      ElMessage.error('文件处理失败: ' + (error.message || '未知错误'));
    }
  }
}

// 预览图标
const previewIcon = () => {
  if (productForm.iconUrl) {
    // 使用 Element Plus 的图片预览功能
    const img = new Image();
    img.src = productForm.iconUrl;
    const newWindow = window.open('');
    newWindow.document.write(img.outerHTML);
  }
}

// 删除图标
const removeIcon = async () => {
  try {
    // 如果是修改模式且有产品ID，调用删除接口
    if (isEdit.value && productForm.id) {
      await ElMessageBox.confirm('确定要删除图标吗？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });

      const response = await request.delete(`/file/delete/icon/${productForm.id}`);
      if (response.code === '200') {
        productForm.iconUrl = '';
        ElMessage.success('图标删除成功');
        // 刷新列表以更新图标显示
        fetchProducts();
      } else {
        ElMessage.error(response.message || '图标删除失败');
      }
    } else {
      // 新增模式，直接清除
      productForm.iconUrl = '';
      productForm.iconFile = null;
      ElMessage.success('图标已移除');
    }
  } catch (error) {
    if (error !== 'cancel') {
      console.error('删除图标失败:', error);
      ElMessage.error('删除图标失败: ' + (error.message || '网络错误'));
    }
  }
}

// 删除程序文件
const removePluginFile = async () => {
  try {
    // 如果是修改模式且有产品ID，调用删除接口
    if (isEdit.value && productForm.id) {
      await ElMessageBox.confirm('确定要删除程序文件吗？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });

      // 重置上传状态
      pluginUploading.value = false;
      uploadProgress.value = 0;

      const response = await request.delete(`/file/delete/plugin/${productForm.id}`);
      if (response.code === '200') {
        productForm.storageUrl = '';
        ElMessage.success('程序文件删除成功');
      } else {
        ElMessage.error(response.message || '程序文件删除失败');
      }
    } else {
      // 新增模式，直接清除
      productForm.storageUrl = '';
      productForm.pluginFile = null;
      pluginUploading.value = false;
      uploadProgress.value = 0;
      ElMessage.success('程序文件已移除');
    }
  } catch (error) {
    if (error !== 'cancel') {
      console.error('删除程序文件失败:', error);
      ElMessage.error('删除程序文件失败: ' + (error.message || '网络错误'));
    }
  }
}


// 获取文件名
const getFileName = (path) => {
  if (!path) return '';
  return path.split('/').pop();
}

// 下载插件
const downloadPlugin = (productId) => {
  if (productId) {
    window.open(`/file/download-plugin/${productId}`, '_blank');
  }
}

// 表单提交
const handleSubmit = async () => {
  // 验证表单
  if (!productFormRef.value) return

  await productFormRef.value.validate(async (valid) => {
    if (!valid) {
      ElMessage.error('请完善表单信息')
      return
    }

    submitLoading.value = true
    try {
      let response

      if (isEdit.value) {
        // 修改插件 - 直接提交表单数据
        response = await request.put('/plugin/update/products', productForm)
      } else {
        // 新增插件 - 先创建插件，再上传文件
        const productData = {
          productCode: productForm.productCode,
          name: productForm.name,
          version: productForm.version,
          price: productForm.price,
          productTypeId: productForm.productTypeId,
          description: productForm.description,
          status: productForm.status
        }

        // 先创建插件基本信息
        response = await request.post('/plugin/add/products', productData)

        if (response.code === '200' && response.data) {
          const productId = response.data.id || response.data
          console.log('新增插件成功，产品ID:', productId)

          // 如果有图标文件，上传图标
          if (productForm.iconFile) {
            try {
              const iconFormData = new FormData()
              iconFormData.append('file', productForm.iconFile)
              const iconResponse = await request.post(`/file/upload/icon/${productId}`, iconFormData, {
                headers: { 'Content-Type': 'multipart/form-data' }
              })
              if (iconResponse.code !== '200') {
                ElMessage.warning('插件创建成功，但图标上传失败: ' + (iconResponse.message || '未知错误'))
              }
            } catch (iconError) {
              console.error('图标上传失败:', iconError)
              ElMessage.warning('插件创建成功，但图标上传失败')
            }
          }

          // 如果有程序文件，上传程序文件
          if (productForm.pluginFile) {
            try {
              const pluginFormData = new FormData()
              pluginFormData.append('file', productForm.pluginFile)
              const pluginResponse = await request.post(`/file/upload/plugin/${productId}`, pluginFormData, {
                headers: { 'Content-Type': 'multipart/form-data' }
              })
              if (pluginResponse.code !== '200') {
                ElMessage.warning('插件创建成功，但程序文件上传失败: ' + (pluginResponse.message || '未知错误'))
              }
            } catch (pluginError) {
              console.error('程序文件上传失败:', pluginError)
              ElMessage.warning('插件创建成功，但程序文件上传失败')
            }
          }
        }
      }

      if (response.code === '200') {
        ElMessage.success(isEdit.value ? '修改成功' : '新增成功')
        dialogVisible.value = false
        fetchProducts() // 刷新列表
      } else {
        ElMessage.error(response.message || (isEdit.value ? '修改失败' : '新增失败'))
      }
    } catch (error) {
      console.error('操作失败:', error)
      ElMessage.error('操作失败: ' + (error.message || '网络错误'))
    } finally {
      submitLoading.value = false
    }
  })
}

// 弹窗关闭处理
const handleDialogClose = () => {
  productFormRef.value?.clearValidate()

  // 重置上传状态
  pluginUploading.value = false;
  uploadProgress.value = 0;

  // 如果是新增操作且未保存成功，重置表单
  if (!isEdit.value && !productForm.id) {
    Object.assign(productForm, {
      id: null,
      productCode: '',
      name: '',
      version: '',
      price: null,
      productTypeId: null,
      productTypeName: '',
      storageUrl: '',
      iconUrl: '',
      description: '',
      status: 1
    })
  }
}

// 上下架操作
const handleStatusChange = async (product) => {
  try {
    const newStatus = product.status === 1 ? 0 : 1
    const actionText = newStatus === 1 ? '上架' : '下架'

    await ElMessageBox.confirm(
        `确定要${actionText}插件 "${product.name}" 吗？`,
        `${actionText}确认`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
    )

    const response = await request.put('/plugin/update/products/status', {
      id: product.id,
      status: newStatus
    })
    if (response.code === '200') {
      ElMessage.success(`${actionText}成功`)
      fetchProducts()
    } else {
      ElMessage.error(response.message || `${actionText}失败`)
    }
  } catch (error) {
    if (error !== 'cancel') {
      console.error('操作失败:', error)
      ElMessage.error('操作失败: ' + (error.message || '网络错误'))
    }
  }
}

// 格式化时间 - 统一格式 YYYY-MM-DD
const formatTime = (time) => {
  if (!time) return '-'
  const date = new Date(time)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

// 获取到期时间状态
const getExpireTimeStatus = (expireTime) => {
  if (!expireTime) return ''

  const now = new Date()
  const expireDate = new Date(expireTime)
  const diffTime = expireDate.getTime() - now.getTime()
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

  if (diffDays < 0) {
    return '(已过期)'
  } else if (diffDays <= 7) {
    return '(即将过期)'
  }
  return ''
}

// 获取到期时间样式类
const getExpireTimeClass = (expireTime) => {
  if (!expireTime) return ''

  const now = new Date()
  const expireDate = new Date(expireTime)
  const diffTime = expireDate.getTime() - now.getTime()
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

  if (diffDays < 0) {
    return 'expired'
  } else if (diffDays <= 7) {
    return 'expiring'
  } else {
    return 'normal' // 添加正常状态的类名
  }
}

// 统计方法
const handleDownloadStats = async (row) => {
  currentProductName.value = row.name
  statsDialogVisible.value = true
  chartLoading.value = true

  try {
    const response = await request.get(`/plugin/download-stats/${row.id}`)
    if (response.code === '200') {
      // 使用 nextTick 确保 DOM 已经更新
      nextTick(() => {
        renderChart(response.data.dailyStats)
      })
    } else {
      ElMessage.error(response.message || '获取下载统计失败')
    }
  } catch (error) {
    console.error('获取下载统计失败:', error)
    ElMessage.error('获取下载统计失败: ' + (error.message || '网络错误'))
  } finally {
    chartLoading.value = false
  }
}

// 渲染图表
const renderChart = (dailyStats) => {
  if (!chartRef.value) return

  // 销毁之前的图表实例
  if (chartInstance) {
    chartInstance.dispose()
  }

  // 初始化图表
  chartInstance = echarts.init(chartRef.value)

  // 处理数据 - 格式化为与示例相同的结构
  const data = dailyStats.map(item => {
    return [item.download_date, item.download_count]
  })

  const dateList = data.map(function (item) {
    return item[0];
  });
  const valueList = data.map(function (item) {
    return item[1];
  });

  // 计算最大值用于颜色映射
  const maxCount = Math.max(...valueList);

  const option = {
    // Make gradient line here - 按照示例的结构
    visualMap: [{
      show: false,
      type: 'continuous',
      seriesIndex: 0,
      min: 0,
      max: maxCount,
      inRange: {
        color: ['#99b1da', '#0a2d67']
      }
    }],
    title: {
      left: 'center',
      text: '近45天下载趋势'
    },
    tooltip: {
      trigger: 'axis',
      formatter: function(params) {
        const data = params[0];
        const originalDate = data.name;
        const date = new Date(originalDate);
        const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
        return `${formattedDate}<br/>下载量: ${data.value}`;
      }
    },
    xAxis: {
      type: 'category',
      data: dateList,
      axisLabel: {

        interval: 4 // 每4个显示一个，避免过于密集
      }
    },
    yAxis: {
      type: 'value'
    },
    series: [{
      type: 'line',
      showSymbol: false,
      data: valueList,
      lineStyle: {
        width: 1
      },
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0,
            color: 'rgb(255,255,255)'
          }, {
            offset: 1,
            color: 'rgb(255,255,255)'
          }]
        }
      }
    }],
    grid: {
      left: '3%',
      right: '4%',
      bottom: '15%',
      top: '15%',
      containLabel: true
    }
  };

  chartInstance.setOption(option)

  // 响应窗口大小变化
  window.addEventListener('resize', handleChartResize)
}

// 图表响应式调整
const handleChartResize = () => {
  if (chartInstance) {
    chartInstance.resize()
  }
}

// 关闭统计弹窗
const handleStatsDialogClose = () => {
  // 移除事件监听
  window.removeEventListener('resize', handleChartResize)

  // 销毁图表实例
  if (chartInstance) {
    chartInstance.dispose()
    chartInstance = null
  }

  statsDialogVisible.value = false
  currentProductName.value = ''
}

// 生命周期钩子
onMounted(async () => {
  // 先获取用户权限
  await getUserPermissions()
  // 获取插件类型
  await fetchPluginTypes()
  // 再获取插件数据
  await fetchProducts()
})

// 在组件卸载前清理
onBeforeUnmount(() => {
  if (chartInstance) {
    chartInstance.dispose()
    chartInstance = null
  }
  window.removeEventListener('resize', handleChartResize)
})
</script>

<style scoped>
.plugin-manage-container {
  padding: 20px;
  margin: 0 auto;
}

.page-title {
  color: #333;
  font-size: 24px;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.search-bar {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: nowrap;
}

.action-buttons {
  display: flex;
  align-items: center;
}

/* 表格样式 */
.product-table {
  margin-top: 20px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

:deep(.el-table__header) {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

:deep(.el-table__header th) {
  font-weight: 600;
  color: #1f2937;
  background-color: #f8fafc !important;
  font-size: 14px;
  letter-spacing: 0.025em;
}

:deep(.el-table__header .cell) {
  font-weight: 600;
  color: #374151;
}

/* 增强表格整体专业感 */
:deep(.el-table) {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

:deep(.el-table th),
:deep(.el-table td) {
  text-align: center;
  border-bottom: 1px solid #f3f4f6;
}

:deep(.el-table .el-table__row:hover > td) {
  background-color: #f9fafb;
}

/* 到期时间样式 */
.expired {
  color: #f56c6c;
  font-weight: bold;
}

.expiring {
  color: #e6a23c;
  font-weight: bold;
}

.normal {
  color: #67c23a;
  font-weight: bold;
}

/* 上传组件样式 */
.icon-upload,
.plugin-upload {
  width: 100%;
}

.el-upload__tip {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
  line-height: 1.4;
}

.icon-preview {
  margin-top: 10px;
  text-align: center;
}

.icon-actions {
  margin-top: 5px;
  display: flex;
  justify-content: center;
  gap: 5px;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  flex-wrap: wrap;
}

/* 上传进度条样式 */
.upload-progress {
  margin-top: 15px;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.progress-text {
  margin-top: 8px;
  text-align: center;
  font-size: 12px;
  color: #666;
}

.success-text {
  color: #67c23a;
  font-weight: bold;
  margin-left: 8px;
}

/* 禁用状态的上传按钮样式 */
:deep(.el-upload .el-button.is-disabled) {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}

/* 禁用状态的样式 */
:deep(.el-input.is-disabled .el-input__inner) {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}

:deep(.el-textarea.is-disabled .el-textarea__inner) {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}

:deep(.el-select.is-disabled .el-input__inner) {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}

/* 图表容器样式 */
.chart-container {
  position: relative;
  min-height: 400px;
}

/* 确保图表正确显示 */
:deep(.el-dialog__body) {
  padding: 20px;
}

/* 分页样式 */
.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  background-color: transparent;
}

:deep(.el-pagination) {
  font-weight: normal;
  background-color: transparent;
}

</style>

